import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'generatePagination',
})
export class GeneratePaginationPipe implements PipeTransform {
	transform(itensArray: any[], maxItensForPage: number = 0): generatePagination {
		const limite = maxItensForPage || 10000;
		const totalItensArray = itensArray.length;
		let i = 0;
		let itensPage: any[] = [];
		const pages: any[] = [];
		const resto = itensArray.length % limite;
		let numberPages = parseInt('' + itensArray.length / limite);
		const itens = itensArray;

		for (i = 0; i < numberPages; i++) {
			itensPage = [];
			for (let x = 0; x < limite; x++) {
				itensPage.push(itens[x + limite * i]);
			}
			pages.push(itensPage);
		}
		itensPage = [];

		if (resto) {
			for (let j = 0; j < resto; j++) {
				itensPage.push(itens[j + limite * i]);
			}
			pages.push(itensPage);
			numberPages += 1;
		}
		const resp: generatePagination = { pages, numberPages, totalItensArray, maxItensForPage };
		return resp;
	}
}

interface generatePagination {
	pages: any[];
	numberPages: number;
	totalItensArray: number;
	maxItensForPage: number;
}
